import React, { useContext } from "react";
import { UserContext } from "contexts/UserContext";
import {
  SettingsSectionContent,
  SettingsSectionItem,
  SettingsSectionItems,
  SettingsSectionHeader,
  SettingsSection,
} from "components/Graphs/SettingsSection";

function ProfileUserMetadata() {
  const userContext = useContext(UserContext);

  return (
    <>
      <SettingsSection>
        <SettingsSectionHeader
          title="Account"
          description="Your user information"
        />
        <SettingsSectionContent>
          <SettingsSectionItems>
            <SettingsSectionItem
              label="Username"
              value={userContext.me?.username}
            />
            <SettingsSectionItem
              label="Brev User ID"
              value={userContext.me?.id}
              showCopyButton
            />
          </SettingsSectionItems>
        </SettingsSectionContent>
      </SettingsSection>
    </>
  );
}

export default ProfileUserMetadata;
